import { Component, OnInit } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { NotificationService } from '../notification.service';
import {MatDialog} from '@angular/material/dialog';
import { AlertComponent } from '../alert/alert.component';
import { StorageService} from '../storage-service.service';
import { DataShareService } from '../cart.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  cartProduct = [];
  cartLength;
  totalAmount : number = 0;
  clickEventsubscription:Subscription;

  constructor(private notifyService : NotificationService, public dialog: MatDialog,
    private dataShareService: DataShareService, private storageService: StorageService) {
      this.clickEventsubscription = this.dataShareService.getClickEvent().subscribe(()=>{
        this.getCartProduct();
        })
     }

  ngOnInit(): void {
    this.getCartProduct();
    this.cartLength = this.cartProduct.length;
    this.calculateTotalAmount();
    this.dataShareService.sendClickEvent();
  }

  calculateTotalAmount() {
    this.totalAmount = 0;
    for (let i = 0; i < this.cartProduct.length; i++) {
      this.totalAmount += this.cartProduct[i].price * this.cartProduct[i].count;
    }
    this.cartLength = this.cartProduct.length;
  }

  getCartProduct() {
    this.cartProduct = JSON.parse(localStorage.getItem('cartProduct'));
    console.log(this.cartProduct);
    this.calculateTotalAmount();
  }

  checkCart(product) {
    let findProduct = this.cartProduct.some(item => item.id == product.id)
    if(findProduct) {
      return 'Add to Cart';
    } else {
      return 'Remove from Cart'
    }
  }

  showToasterSuccess(message){
    this.notifyService.openSnackBar(message);
  }


  clearCart(){
    this.cartProduct = [];
    localStorage.setItem('cartProduct', JSON.stringify(this.cartProduct));
    this.dataShareService.sendClickEvent();
  }

  checkPrice(product){
   return product.count * product.price;
  }

  removeProduct(cartItem){
    const dialogRef = this.dialog.open(AlertComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if(result){
        this.checkCartProduct(cartItem);
      } else {
        return;
      }
    });
  }

  checkCartProduct(product) {
    let findProduct = this.cartProduct.some(item => item.id == product.id)
    if(!findProduct) {
      this.cartProduct.push(product);
      this.showToasterSuccess('Product added in your cart list!');
    } else {
      let removeProduct = this.cartProduct.filter(item => item.id !== product.id);
      this.cartProduct = removeProduct;
      this.showToasterSuccess('Product removed in your cart list!');
    }
    this.calculateTotalAmount();
    this.storageService.setItem('cartProduct',JSON.stringify(this.cartProduct));
    this.dataShareService.sendClickEvent();
  }

}
